import { IListingStatsResponse, IListingStatsByCategory } from "../../../../models/Part";
import PriceFormat from "../../../../utils/priceFormat";
import DashboardTile from "../../../dashboard/DashboardTile";

export default function ListedStatsTable({ listingStats, }: { listingStats: IListingStatsResponse; }) {

  const renderCategoryTable = (data: IListingStatsByCategory[]) => (
    <table className="min-w-full border-collapse">
      <thead>
        <tr className="border-b border-gray-300 text-left text-sm font-semibold text-gray-700">
          <th className="py-2 px-3 w-1/3">Category</th>
          <th className="py-2 px-3 text-right">Total Active</th>
          <th className="py-2 px-3 text-right">Average Age</th>
          <th className="py-2 px-3 text-right">Over 30 Days</th>
          <th className="py-2 px-3 text-right">Average Price</th>
          <th className="py-2 px-3 text-right">Total Price</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {data.length > 0 ? (
          data.map((row) => (
            <tr key={row.category?.id}>
              <td className="py-2 px-3 font-medium text-gray-900">
                {row.category?.name || "Unknown"}
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {row.totalActive}
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {row.over30DaysOld}
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {Math.round(row.averageAge || 0)}
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {PriceFormat(row.averagePrice)}
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {PriceFormat(row.totalPrice)}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5} className="py-4 text-center text-gray-500 italic">
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );

  return (
    <DashboardTile span={2}>
      <div className="">
        <div className="mb-4 flex items-center justify-between">
          <div className="prose">
            <h3 className="m-0">By Category</h3>
          </div>
        </div>

        <div className="overflow-x-auto overflow-y-scroll max-h-[25vh]">
          {renderCategoryTable(listingStats.byCategory)}
        </div>
      </div>
    </DashboardTile>
  );
}

